/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).__Zone_disable_customElements =
    true;
}
